import { createPopper } from '@popperjs/core';

(function () {
    let popperInstance = null;
    let tooltipIdCounter = 0;

    const getTextFrom = (el) => {
        const title = el.getAttribute('data-original-title') || el.getAttribute('title');
        if (!el.hasAttribute('data-original-title')) {
            el.setAttribute('data-original-title', title);
            el.removeAttribute('title');
        }
        return title;
    };

    const createTooltipElement = (text, id) => {
        const wrapper = document.createElement('span');
        wrapper.className = 'tooltip';
        wrapper.setAttribute('role', 'tooltip');
        wrapper.setAttribute('id', id);
        wrapper.innerHTML = `${text}<span class="arrow" data-popper-arrow></span>`;
        return wrapper;
    };

    const showTooltip = (el) => {
        const text = getTextFrom(el);
        const id = `tooltip-id-${++tooltipIdCounter}`;

        const tooltip = createTooltipElement(text, id);
        el.setAttribute('aria-describedby', id);
        el.insertAdjacentElement('beforebegin', tooltip);
        tooltip.setAttribute('data-show', '');

        popperInstance = createPopper(el, tooltip, {
            placement: 'top',
            modifiers: [{ name: 'offset', options: { offset: [0, 12] } }],
        });
    };

    const hideTooltip = () => {
        document.querySelectorAll('[role="tooltip"]').forEach(t => {
            const trigger = document.querySelector(`[aria-describedby="${t.id}"]`);
            if (trigger) trigger.removeAttribute('aria-describedby');
            t.remove();
        });
        popperInstance?.destroy();
        popperInstance = null;
    };

    const addTooltipEventListeners = (el, showEvents, hideEvents) => {
        showEvents.forEach(evt => el.addEventListener(evt, () => showTooltip(el)));
        hideEvents.forEach(evt => el.addEventListener(evt, hideTooltip));
        el.addEventListener('click', (e) => {
            e.preventDefault();
            hideTooltip();
            showTooltip(el);
        });
        addTooltipKeyboardAccessibility(el);
    };

    const addTooltipKeyboardAccessibility = (el) => {
        el.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                if (el.getAttribute('aria-describedby')) {
                    hideTooltip();
                } else {
                    showTooltip(el);
                }
            }
            if (e.key === 'Escape') {
                hideTooltip();
            }
        });
    };

    const bindTooltipEvents = () => {
        const showEvents = ['mouseenter', 'focus'];
        const hideEvents = ['mouseleave', 'blur'];

        document.querySelectorAll('[data-toggle="tooltip"]').forEach((el) => {
            addTooltipEventListeners(el, showEvents, hideEvents);
        });
    };

    bindTooltipEvents();
})();
